import { render, staticRenderFns } from "./epmallsettleorder.vue?vue&type=template&id=21330b9b"
import script from "./epmallsettleorder.vue?vue&type=script&lang=js"
export * from "./epmallsettleorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports